import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ea3263c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "container-fluid",
  id: "footer"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"col-sm-1\" data-v-ea3263c2></div><div class=\"col-sm\" id=\"pages\" data-v-ea3263c2><span class=\"footer-heading\" data-v-ea3263c2>PAGES</span><div class=\"footer-sub\" data-v-ea3263c2><a class=\"footer-text\" href=\"/home\" data-v-ea3263c2>Home</a><a class=\"footer-text\" href=\"/blog\" data-v-ea3263c2>Blog Posts</a><details class=\"footer-collapsible\" data-v-ea3263c2><summary class=\"footer-text footer-toggle\" data-v-ea3263c2>Packages</summary><div class=\"footer-nested\" data-v-ea3263c2><details class=\"footer-collapsible nested\" data-v-ea3263c2><summary class=\"footer-text footer-toggle\" data-v-ea3263c2>Link 1</summary><div class=\"footer-nested\" data-v-ea3263c2><a class=\"footer-text\" href=\"/packages/link1/sublink1\" data-v-ea3263c2>Sub Link 1</a><a class=\"footer-text\" href=\"/packages/link1/sublink2\" data-v-ea3263c2>Sub Link 2</a><a class=\"footer-text\" href=\"/packages/link1/sublink3\" data-v-ea3263c2>Sub Link 3</a><a class=\"footer-text\" href=\"/packages/link1/sublink4\" data-v-ea3263c2>Sub Link 4</a></div></details><a class=\"footer-text\" href=\"/packages/link2\" data-v-ea3263c2>Link 2</a><a class=\"footer-text\" href=\"/packages/link3\" data-v-ea3263c2>Link 3</a></div></details><details class=\"footer-collapsible\" data-v-ea3263c2><summary class=\"footer-text footer-toggle\" data-v-ea3263c2>About Us</summary><div class=\"footer-nested\" data-v-ea3263c2><a class=\"footer-text\" href=\"/page/who-we-are\" data-v-ea3263c2>Who We Are</a><a class=\"footer-text\" href=\"/page/what-we-do\" data-v-ea3263c2>What We Do</a></div></details><a class=\"footer-text\" href=\"/itenary\" data-v-ea3263c2>Contact Us</a></div></div><div class=\"col-sm\" id=\"followus\" data-v-ea3263c2><span class=\"footer-heading\" id=\"follow-text\" data-v-ea3263c2>FOLLOW US</span><div class=\"footer-sub\" data-v-ea3263c2><a class=\"footer-text\" href=\"#\" data-v-ea3263c2><i class=\"fa fa-facebook\" id=\"social-icons\" style=\"padding:0px 12px 0px 0px;\" data-v-ea3263c2></i> FACEBOOK</a><a class=\"footer-text\" href=\"#\" data-v-ea3263c2><i class=\"fa fa-instagram\" id=\"social-icons\" data-v-ea3263c2></i> INSTAGRAM</a><a class=\"footer-text\" href=\"#\" data-v-ea3263c2><svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" class=\"x-social-icon\" style=\"fill:white;vertical-align:middle;\" data-v-ea3263c2><path d=\"M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.74l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z\" data-v-ea3263c2></path></svg> X </a></div></div><div class=\"col-sm\" id=\"support\" data-v-ea3263c2><span class=\"footer-heading\" data-v-ea3263c2>SUPPORT</span><div class=\"footer-sub\" data-v-ea3263c2><a class=\"footer-text\" href=\"#\" data-v-ea3263c2>Terms &amp; Conditions</a><a class=\"footer-text\" href=\"#\" data-v-ea3263c2>Privacy Policy</a></div></div>", 4)
const _hoisted_7 = {
  class: "col-sm",
  id: "sectors"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "footer-heading" }, "SECTORS", -1))
const _hoisted_9 = { class: "footer-sub" }
const _hoisted_10 = /*#__PURE__*/_createTextVNode("Tourism")
const _hoisted_11 = { class: "footer-collapsible nested" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("summary", { class: "footer-text footer-toggle" }, "Verticals", -1))
const _hoisted_13 = { class: "footer-nested" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode("EAT")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("SLEEP")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("SEE")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("DO")
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-sm-1" }, null, -1))
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-sm-12 text-center" }, [
    /*#__PURE__*/_createElementVNode("p", { id: "copyrights" }, " 2020 © Copyrights. Find It Smart Global Pty Ltd. All Rights Reserved ")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_router_link, {
            class: "footer-text",
            to: "/page/tourism"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createElementVNode("details", _hoisted_11, [
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_router_link, {
                class: "footer-text",
                to: "/page/eat"
              }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "footer-text",
                to: "/page/sleep"
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "footer-text",
                to: "/page/see"
              }, {
                default: _withCtx(() => [
                  _hoisted_16
                ]),
                _: 1
              }),
              _createVNode(_component_router_link, {
                class: "footer-text",
                to: "/page/do"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ])
        ])
      ]),
      _hoisted_18
    ]),
    _hoisted_19
  ]))
}